import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../../../Shared/colors";
import {
  useGetSingleHierarchyQuery,
} from "../../../features/employeeSlice";
import { TeamTable } from "./TeamTable";
import { ManageTeamTable } from "./ManageTeamTable";
import ExelPopup from "./ExelPopup";
import { decryptData } from "../../../services/crypto";
import { usePaginationFromURL } from "../../../hooks/usePaginationFromURL";

export const ManageTeamFirst = () => {
  // Use URL-based pagination hook (Note: DataGrid uses 0-indexed pages for client-side pagination)
  const { currentPage: urlPage, pageSize, setPage: setUrlPage, setPageSize } = usePaginationFromURL({
    defaultPage: 1,
    defaultPageSize: 50
  });
  // Convert to 0-indexed for DataGrid (client-side pagination)
  const currentPage = urlPage - 1;
  const setCurrentPage = (page) => {
    const pageNum = typeof page === 'function' ? page(currentPage) : page;
    setUrlPage(pageNum >= 0 ? pageNum + 1 : 1);
  };
  const [teamPopUp, setTeamPopUp] = useState(false)
  const [teamExelPopUp, setTeamExelPopUp] = useState(false)
  const [teamId, setteamId] = useState('')


  let staffId = null;
  let storedStaffId = localStorage.getItem("id");

  if (storedStaffId) {
    try {
      staffId = decryptData(storedStaffId);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  /*
    includeBlocked: this screen exists to hand clients to a named person, and a
    suspended salesperson is still someone you may want to park a book with.
    The table badges them, so the choice is visible at the moment it is made.
    Leavers stay out — their work was already handed over when they left.
  */
  const { data: staff, isFetching } = useGetSingleHierarchyQuery({
    staffId,
    includeBlocked: true,
  });

  return (
    <Main>
      {/*
        Table lives in ManageTeamTable; this stays the container that owns the
        two assign dialogs. URL pagination is preserved and converted from the
        hook's 1-indexed page to DataGrid's 0-indexed one here.
      */}
      <ManageTeamTable
        team={staff}
        isFetching={isFetching}
        page={currentPage}
        onPageChange={setCurrentPage}
        pageSize={pageSize}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setCurrentPage(0);
        }}
        onAssignClients={(row) => {
          setteamId(row.id);
          setTeamPopUp(true);
        }}
        onAssignFromExcel={(row) => {
          setteamId(row.id);
          setTeamExelPopUp(true);
        }}
      />
      <PopUpContainer popUp={teamPopUp}>
        <PopUp>
          <Cross
            onClick={() => setTeamPopUp(!teamPopUp)}
            style={{ height: "3%" }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <PopUpSection style={{ height: "90%" }}>
            <TeamTable teamId={teamId} />
          </PopUpSection>
        </PopUp>
      </PopUpContainer>

      <PopUpContainer popUp={teamExelPopUp}>
        <PopUp style={{
          width: "50%",
          height: "40%",
        }}>
          <Cross
            onClick={() => setTeamExelPopUp(!teamExelPopUp)}
            style={{ height: "5%" }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <PopUpSection style={{ height: "90%" }}>
            <ExelPopup teamId={teamId} />
          </PopUpSection>
        </PopUp>
      </PopUpContainer>

    </Main>
  );
};

const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: ${colors.white};
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;




const PopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 11;
  display: ${(porps) => (porps.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
`;

const PopUp = styled.div`
  width: 90vw;
  height: 90vh;
  overflow: scroll;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
`;

const Cross = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 2em;
  margin-top: 2em;
  img {
    height: 90%;
    object-fit: contain;
    cursor: pointer;
  }
`;

const PopUpSection = styled.div`
  margin-bottom: 3em;
  width: 100%;
  background-color: ${colors.white};
  display: flex;
  justify-content: space-around;
`;
